import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';
import { Betolto } from '../ui/elemek.tsx';
import { useAuth } from './AuthAllapot.tsx';
import { utDontes } from './belepes.ts';

export default function VedettUt() {
  const { allapot } = useAuth();
  const hely = useLocation();
  const queryClient = useQueryClient();

  // Kijelentkezéskor ürítjük a gyorsítótárat, hogy egy másik felhasználó ne lássa az előző adatait.
  useEffect(() => {
    if (allapot === 'kijelentkezve') queryClient.clear();
  }, [allapot, queryClient]);

  if (allapot === 'betolt') return <Betolto />;
  const cel = utDontes(allapot, hely.pathname + hely.search);
  if (cel) return <Navigate replace to={cel} />;
  return <Outlet />;
}
